import type { GraphqlError, GraphqlResult } from './bff-graphql-client';
import { BffGraphqlClient } from './bff-graphql-client';

export type { GraphqlError, GraphqlResult } from './bff-graphql-client';
export { BffGraphqlClient, createBffGraphqlClient } from './bff-graphql-client';

export function assertNoGraphqlErrors(
  operation: string,
  errors: readonly GraphqlError[] | undefined
): void {
  if (errors?.length) {
    const error = new Error(
      `${operation} failed: ${errors.map((item) => item.message).join('; ')}`
    );
    error.name = errors[0]?.errorType ?? 'GraphqlError';
    throw error;
  }
}

let cachedClient: BffGraphqlClient | undefined;

export function setCustomGraphqlClient(client: BffGraphqlClient | undefined): void {
  cachedClient = client;
}

export function getCustomGraphqlClient(): BffGraphqlClient {
  if (!cachedClient) {
    throw new Error('BFF GraphQL client has not been configured');
  }
  return cachedClient;
}

export async function executeCustomGraphql<TData>(params: {
  query: string;
  variables?: Record<string, unknown>;
}): Promise<GraphqlResult<TData>> {
  return getCustomGraphqlClient().execute<TData>(params);
}
